import { createSlice } from '@reduxjs/toolkit';

interface HamburgMenuState {
  isOpen: boolean;
}

const initialState: HamburgMenuState = {
  isOpen: false,
};

const hamburgMenuSlice = createSlice({
  name: 'hamburgMenu',
  initialState,
  reducers: {
    closeMenu(state) {
      state.isOpen = false;
    },
    toggleMenu(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { closeMenu, toggleMenu } = hamburgMenuSlice.actions;

export default hamburgMenuSlice.reducer;
